// extracted by mini-css-extract-plugin
export default {"previewHighlightBackground":"rgba(38,132,255,.2)","spinner":"PDFViewer-module__spinner--fdb00"};